import React, { useEffect, useMemo, useRef } from "react";
import { Col, Container, Row } from "react-grid-system";
import { get, isEmpty } from "lodash";
import styled from "styled-components";
import { NumericFormat } from "react-number-format";
import ReactToPrint from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { BaseButton, Flex, Text } from "components";
import { fetchCourierCompanies } from "app/slices/myuhlSlices/manifestCourierCompaniesSlice/manifestCourierCompaniesSlice";
import ExportToExcelManifest from "../components/ExcelManifest";

export const PrintManifestsTable = styled.div`
  width: 100%;
  @media print {
    thead {
      display: table-row-group;
    }
  }
  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
  }
  th,
  td {
    border: 1px solid #000;
    word-wrap: break-word;
    padding: 8px 4px;
    font-weight: 500;
    font-size: 12px;
    color: #000;
  }
`;

const PrintManifestContainer = () => {
    const manifestListRef = useRef();
    const dispatch = useDispatch();
    const reysNumber = useSelector(
        (store) => store.myuhl.manifestAllSlice.reysNumber);
    // senders
    const ToCourierCompanies = useSelector((store) =>
        get(
            store,
            "myuhl.manifestCourierCompaniesSlice.data.courierCompanies.data.[0]",
            []
        )
    );

    const FromCourierCompanies = useSelector((store) =>
        get(
            store,
            "myuhl.manifestCourierCompaniesSlice.data.courierCompanies.data[1]",
            []
        )
    ); // end senders

    const manifestsAllDataStore = useSelector((store) =>
        get(store, "myuhl.manifestAllSlice.data.manifestAll.data", [])
    );

    const isManifestsAllDataFetched = useSelector((store) =>
        get(store, "myuhl.manifestAllSlice.data.loading", true)
    );
    const isCourierCompaniesFetched = useSelector((store) =>
        get(store, "myuhl.manifestCourierCompaniesSlice.data.loading", true)
    );
    // const Manifests = manifestsAllDataStore.filter(
    //     (item) => get(item, "checked", false) === true
    // );

    // const manfiestWTotal = useMemo(() => {
    //     const rslt = {};
    //     rslt["code"] = "Total";
    //     rslt["totalProductPrice"] = Manifests.map((manifest) => ({
    //         ...manifest,
    //         postProducts: get(manifest, "postProducts", []).reduce(
    //             (accumulator, currentValue) =>
    //                 accumulator + +currentValue.price,
    //             0
    //         ),
    //     })).reduce(
    //         (accumulator, currentValue) =>
    //             accumulator + +currentValue.postProducts,
    //         0
    //     );
    //     rslt["weight"] = Manifests.reduce(
    //         (total, item) => total + +item.weight,
    //         0
    //     );

    //     return [...Manifests, rslt];
    // }, [Manifests]);
    // totals
    const Manifests = manifestsAllDataStore.filter(
        (item) => get(item, "checked", false) === true
    );

    const totals = {
        weight: Manifests.reduce((sum, x) => sum + (Number(x.weight) || 0), 0),
        totalProductPrice: Manifests.reduce(
            (sum, x) => sum + (x.totalProductPrice || 0),
            0
        ),
    };

    useEffect(() => {
        dispatch(fetchCourierCompanies());
    }, []);


    return (
        <>
            <Container fluid>
                <Row>
                    <Col xs={12} className="mb-8">
                        <h2>Манифест / Распечатать</h2>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} align="center">
                        <Container ref={manifestListRef} style={{ width: "1000px" }}>
                            {/* Courier info */}
                            <Row justify="space-around" className="mt-32">
                                <Col xs={4} className="card">
                                    <Text bold>
                                        Courier company's name and address{" "}
                                    </Text>{" "}
                                    {get(ToCourierCompanies, "name", "")}{" "}
                                    {get(ToCourierCompanies, "address", "")}{" "}
                                </Col>
                                <Col xs={4} className="card">
                                    <Text bold>
                                        Courier company's name and address
                                    </Text>{" "}
                                    {get(FromCourierCompanies, "name", "")}{" "}
                                    {get(
                                        FromCourierCompanies,
                                        "address",
                                        ""
                                    )}{" "}
                                </Col>
                            </Row>

                            {/* Manifest Table */}
                            <Row className="mb-32 mt-64">
                                <Col xs={12}>
                                    <PrintManifestsTable>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th colSpan={9}>
                                                        <b>
                                                            Name of documents in cargo manifest / Перечень
                                                            сведений, указываемых в манифесте
                                                        </b>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan={9}>
                                                        <b>
                                                            Waybill name / Номер транспортной накладной -{" "}
                                                            {reysNumber}
                                                        </b>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>№</th>
                                                    <th>Invoice numbers / Номера инфойсов</th>
                                                    <th>Receiver's name / Ф.И.О получателя</th>
                                                    <th>PINFL / ПИНФЛ получателя</th>
                                                    <th>
                                                        Passport number / Серия и № паспорта получателя
                                                    </th>
                                                    <th>Gross weight / Вес брутто посылки</th>
                                                    <th>Total price in / Итого цена</th>
                                                    <th>Items / Наименования</th>
                                                    <th>Address / Адрес</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!isEmpty(Manifests) ? (
                                                    Manifests.map((item, index) => (
                                                        <tr key={index + 1}>
                                                            <td>{index + 1}</td>
                                                            <td>{get(item, "code", "")}</td>
                                                            <td>{get(item, "receiver", "")}</td>
                                                            <td>{get(item, "pinfl", "")}</td>
                                                            <td>{get(item, "passport", "")}</td>
                                                            <td>
                                                                <NumericFormat
                                                                    displayType="text"
                                                                    value={get(item, "weight", 0) / 1000}
                                                                    thousandSeparator
                                                                    fixedDecimalScale
                                                                    decimalScale={2}
                                                                />
                                                            </td>
                                                            <td>
                                                                <NumericFormat
                                                                    displayType="text"
                                                                    value={get(item, "totalProductPrice", 0)}
                                                                    thousandSeparator
                                                                    decimalScale={2}
                                                                    fixedDecimalScale
                                                                />
                                                            </td>
                                                            <td style={{ textAlign: "left", minWidth: 150, padding: 0 }}>
                                                                <div
                                                                    style={{
                                                                        display: "grid",
                                                                        padding: 0,
                                                                        gridTemplateColumns: "1fr 1fr 1fr"
                                                                    }}
                                                                >

                                                                    {get(item, "postProducts", []).length < 2 ?

                                                                        get(item, "postProducts", []).map((p, i) => (
                                                                            <React.Fragment key={i}>
                                                                                {/* First column (no left border) */}
                                                                                <div style={{
                                                                                    padding: "6px", minWidth: 50
                                                                                }}>
                                                                                    {get(p, "productName", "")}
                                                                                </div>

                                                                                {/* Middle column (borders left + bottom) */}
                                                                                <div
                                                                                    style={{
                                                                                        padding: "6px"
                                                                                    }}
                                                                                >
                                                                                    {get(p, "quantity", "")}
                                                                                </div>

                                                                                {/* Last column (only bottom border) */}
                                                                                <div
                                                                                    style={{
                                                                                        padding: "6px"
                                                                                    }}
                                                                                >
                                                                                    {get(p, "price", "")}
                                                                                </div>
                                                                            </React.Fragment>
                                                                        ))
                                                                        : get(item, "postProducts", []).map((p, i) => (
                                                                            <React.Fragment key={i}>
                                                                                {/* First column (no left border) */}
                                                                                <div style={{
                                                                                    borderBottom: i === get(item, "postProducts", []).length - 1 ? "none" : "0.4px solid black",
                                                                                    padding: "6px", minWidth: 100
                                                                                }}>
                                                                                    {get(p, "productName", "")}
                                                                                </div>

                                                                                {/* Middle column (borders left + bottom) */}
                                                                                <div
                                                                                    style={{
                                                                                        borderLeft: "0.4px solid black",
                                                                                        borderBottom: i === get(item, "postProducts", []).length - 1 ? "none" : "0.4px solid black",
                                                                                        padding: "6px"
                                                                                    }}
                                                                                >
                                                                                    {get(p, "quantity", "")}
                                                                                </div>

                                                                                {/* Last column (only bottom border) */}
                                                                                <div
                                                                                    style={{
                                                                                        borderLeft: "0.4px solid black",
                                                                                        borderBottom: i === get(item, "postProducts", []).length - 1 ? "none" : "0.4px solid black",
                                                                                        padding: "6px"
                                                                                    }}
                                                                                >
                                                                                    {get(p, "price", "")}
                                                                                </div>
                                                                            </React.Fragment>
                                                                        ))}

                                                                </div>
                                                            </td>
                                                            <td>{get(item, "address", "")}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={9}>No Data</td>
                                                    </tr>
                                                )}
                                                {/* Totals */}
                                                <tr>
                                                    <td colSpan={5}>
                                                        <b>Total</b>
                                                    </td>
                                                    <td>{totals.weight / 1000}</td>
                                                    <td>{totals.totalProductPrice}</td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </PrintManifestsTable>
                                </Col>
                            </Row>

                            {/* Footer */}
                            <Row className="mt-64 mb-16 ml-8">
                                <Col>SIGNATURE AND STAMP / ПОДПИСЬ И ПЕЧАТЬ</Col>
                            </Row>
                            <Row className="mt-8 mb-64 ml-8">
                                <Col>
                                    Description / Примечание:
                                    __________________________________________
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Print Button */}
            <Row>
                {!isManifestsAllDataFetched && !isCourierCompaniesFetched ? (
                    <>
                        <Col xs={12} className={"mt-32 mb-64"} align="center">
                            <Flex style={{ gap: "8px", justifyContent: "center" }}>


                                <ReactToPrint
                                    trigger={() => {
                                        return (
                                            <BaseButton primary>Печать</BaseButton>
                                        );
                                    }}
                                    content={() => manifestListRef.current}
                                    pageStyle={"print"}
                                    documentTitle={"Манифест лист"}
                                />
                                <ExportToExcelManifest
                                    data={Manifests}
                                    nameTo={get(ToCourierCompanies, "name", "")}
                                    addressTo={get(ToCourierCompanies, "address", "")}
                                    nameFrom={get(FromCourierCompanies, "name", "")}
                                    addressFrom={get(FromCourierCompanies, "address", "")}
                                    reysNumber={reysNumber}
                                    isCheckedParcels={true}
                                    style={{ marginLeft: "16px" }}
                                >
                                    Скачать в Excel
                                </ExportToExcelManifest>
                            </Flex>
                        </Col>
                    </>
                ) : (
                    <></>
                )}
            </Row>
        </>
    );
};

export default PrintManifestContainer;
